import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  localsActions,
  LocalsKeysKeys,
  LocalsState,
  selectLocals,
} from "../../shared/data-access/store/locals/localsSlice";

const useLocals = () => {
  const dispatch = useDispatch();
  const locals = useSelector(selectLocals);
  const localsRef = useRef(locals);

  useEffect(() => {
    localsRef.current = locals;
  }, [locals]);

  const setValue = useCallback(
    (key: LocalsKeysKeys, value: LocalsState[typeof key]) => {
      dispatch(localsActions.setValue({ key, value }));
    },
    [dispatch]
  );

  const getValue = useCallback(
    (key: LocalsKeysKeys) => localsRef.current[key],
    []
  );

  const reset = useCallback(() => {
    dispatch(localsActions.reset());
  }, [dispatch]);

  return {
    setValue,
    reset,
    getValue,
  };
};

export default useLocals;
